<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-settings">{{
              $t("dashboardCardUserSettingsTitle")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0 animated fadeIn">
            <!-- DOVOLJENJA -->
            <v-card
              class="#505050--text mb-1"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: white'
                  : 'border: none; background-color: white'
              "
            >
              <v-card-title>
                <span class="headline">
                  {{ $t("userSettingsPermissionsTitle") }}
                </span>
              </v-card-title>
              <v-card-text class="pb-0 mb-0">
                <v-layout wrap>
                  <v-switch
                    class="ma-0 pa-0"
                    v-model="allowFCMOrderNotification"
                    :label="$t('userSettingsallowFCMOrderNotificationTitle')"
                    @click="checkFCMAllow"
                  ></v-switch>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-form ref="form" v-model="valid">
              <!-- ADMINISTRACIJA -->
              <v-card
                v-show="
                  $store.state.storeAuth.userProfile.isAdmin &&
                  $store.state.storeAuth.userProfile.client ==
                    $store.state.storeClient.client.basicSettings.name
                "
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  <span class="headline">
                    {{ $t("userSettingsAdminTitle") }}
                  </span>
                </v-card-title>
                <v-card-text class="pb-0 mb-0">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select
                        v-model="editedItem.isAdminShowPackages"
                        :items="$store.state.storeDelivery.delivery"
                        item-text="name"
                        item-value="name"
                        deletable-chips
                        small-chips
                        attach
                        chips
                        :label="$t('userSettingsAdminShowPackagesTitle')"
                        multiple
                        dense
                      ></v-select>
                      <v-switch
                        class="ma-0 pa-0"
                        v-model="editedItem.isAdminSendNewPackagesMessage"
                        :label="
                          $t('userSettingsAdminSendNewPackageMessageTitle')
                        "
                      ></v-switch>
                      <v-switch
                        v-show="
                          $store.state.storeClient.client.modules
                            .moduleModerator.active
                        "
                        class="ma-0 pa-0"
                        v-model="editedItem.isModerator"
                        :label="$t('settingsUserRightsisModerator')"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- OSEBNI PODATKI -->
              <v-card
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  <span class="headline">
                    {{
                      editedItem.isCompany
                        ? $t("userSettingsCompanyInfoTitle")
                        : $t("userSettingsPersonalInfoTitle")
                    }}
                  </span>
                </v-card-title>
                <v-card-text class="pb-0 mb-0">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-switch
                        class="ma-0 pa-0"
                        v-model="editedItem.isCompany"
                        :label="$t('userSettingsIsCompanyTitle')"
                      ></v-switch>
                      <v-text-field
                        v-show="editedItem.isCompany"
                        class="mb-1"
                        v-model="editedItem.vatNumber"
                        :label="$t('userSettingsVatNumberTitle')"
                        :rules="[validateMaxLength(50)]"
                        :counter="50"
                      ></v-text-field>
                      <v-text-field
                        class="mb-1"
                        v-model="editedItem.fullName"
                        :label="
                          editedItem.isCompany
                            ? $t('userSettingsCompanyFullNameTitle')
                            : $t('userSettingsFullNameTitle')
                        "
                        :rules="[validateRequired(), validateMaxLength(50)]"
                        :counter="50"
                      ></v-text-field>
                      <v-text-field
                        class="mb-1"
                        v-model="editedItem.address1"
                        :label="
                          editedItem.isCompany
                            ? $t('userSettingsCompanyAddress1Title')
                            : $t('userSettingsAddress1Title')
                        "
                        :rules="[validateRequired(), validateMaxLength(50)]"
                        :counter="50"
                      ></v-text-field>
                      <v-text-field
                        class="mb-1"
                        v-model="editedItem.address2"
                        :label="$t('userSettingsAddress2Title')"
                        :rules="[validateRequired(), validateMaxLength(50)]"
                        :counter="50"
                      ></v-text-field>
                      <v-select
                        item-text="title"
                        item-value="cShort"
                        :items="countryItems"
                        v-model="editedItem.country"
                        :label="$t('userSettingsCountryTitle')"
                        :rules="[validateRequired()]"
                      ></v-select>
                      <v-text-field
                        class="mb-1"
                        v-model="editedItem.phone"
                        :label="$t('userSettingsPhoneTitle')"
                        :rules="[validateRequired(), validateMaxLength(50)]"
                        :counter="50"
                      ></v-text-field>
                      <v-text-field
                        class="mb-1"
                        v-model="editedItem.email"
                        :label="$t('userSettingsEmailTitle')"
                        :rules="[
                          validateRequired(),
                          validateIsEmail(),
                          validateMaxLength(100),
                        ]"
                        :counter="100"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-12 pa-0">
            <!-- JEZIK -->
            <v-card
              class="#505050--text"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: white'
                  : 'border: none; background-color: white'
              "
            >
              <v-card-title>
                <span class="headline">{{ $t("lmFlagSelectBtnTitle") }}</span>
              </v-card-title>
              <v-card-text class="pb-0 mb-0">
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                      item-text="title"
                      item-value="langShort"
                      :items="flagItems"
                      v-model="language"
                      @change="changeLang(language)"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- GUMB NAZAJ -->
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>
          <!-- GUMB SHRANI -->
          <simple-navigation-button
            right
            :title="$t('addEditFormSaveButton')"
            icon="mdi-content-save"
            @clicked="saveUserSettings"
          ></simple-navigation-button>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import Vue from "vue";
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

import VueCookies from "vue-cookies";
import { flagLang } from "@/localization/flagLang";

export default {
  name: "userSettings",
  components: {
    AppNavigation,
    SimpleNavigationButton,
    MainSubPageToolbar,
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png"),
      valid: true,
      flagItems: flagLang,
      language: "en",
      allowFCMOrderNotification:
        this.$store.state.storeAuth.userProfile.allowFCMOrderNotification,
      editedItem: {
        isCompany: this.$store.state.storeAuth.userProfile.isCompany,
        vatNumber: this.$store.state.storeAuth.userProfile.vatNumber,
        fullName: this.$store.state.storeAuth.userProfile.fullName,
        address1: this.$store.state.storeAuth.userProfile.address1,
        address2: this.$store.state.storeAuth.userProfile.address2,
        country: this.$store.state.storeAuth.userProfile.country,
        phone: this.$store.state.storeAuth.userProfile.phone,
        email: this.$store.state.storeAuth.userProfile.email,
        isModerator: this.$store.state.storeAuth.userProfile.isModerator,
        isAdminShowPackages:
          this.$store.state.storeAuth.userProfile.isAdminShowPackages,
        isAdminSendNewPackagesMessage:
          this.$store.state.storeAuth.userProfile.isAdminSendNewPackagesMessage,
      },
    };
  },
  mounted() {
    this.language = VueCookies.get("lang");
  },
  methods: {
    changeLang(lng) {
      Vue.i18n.set(lng);
      VueCookies.set("lang", lng);
    },
    async checkFCMAllow() {
      try {
        await this.$store.dispatch(
          "setFCMAllow",
          !this.allowFCMOrderNotification
        );
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
      }
    },
    async saveUserSettings() {
      if (this.$refs.form.validate()) {
        //console.log(this.editedItem);
        try {
          let result = await this.$store.dispatch(
            "saveUserSettings",
            this.editedItem
          );
          if (result) {
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } else {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("msgErrorSave"),
            });
          }
        } catch (error) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: error,
          });
        }
      }
    },
  },
};
</script>
